import { render, staticRenderFns } from "./RecipeRecord.vue?vue&type=template&id=e98bfdb6&scoped=true"
import script from "./RecipeRecord.vue?vue&type=script&lang=js"
export * from "./RecipeRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98bfdb6",
  null
  
)

export default component.exports